module.exports = __webpack_public_path__ + "img/165.b8f2dbf2.png";